import axios from "axios";
import { URLADRESS } from "../../utils/constants";

const api = axios.create({
    baseURL: URLADRESS,
    withCredentials: true,
});

export { api };
